import React from 'react';
import Features from '../Features/Features';
import styles from './AboutContent.module.css';

function AboutContent({ title, description, features }) {
    return (
        <section className={`navbarOffsetHeight ${styles.aboutContent}`}>
            <div className={styles.introContent}>
                <h2>{title}</h2>
                <p>{description}</p>
            </div>

            <Features features={features} />
        </section>
    );
}

export default AboutContent;